import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../images/logo/MCQWALE-LOGO-TM_CL.png";
import ApiService from "../../service/ApiService";
import { apiPaths } from "../../service/apiPaths";
import { useAppDispatch } from "../../store/hooks";
import { loginSuccess, loginFailure, setLoading } from "../../store/slices/authSlice";


const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoginLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoginLoading(true);
    setError("");

    try {
      const res = await ApiService({
        method: 'POST',
        endpoint: apiPaths.login,
        data: { email: username, password },
      });
      
      console.log("Login response:", res);
      
      if (res.success && res.user && res.token) {
        // Store token in localStorage
        // localStorage.setItem('admin_authToken', res.token);
        
        // Update Redux store
        dispatch(loginSuccess({ user: res.user, token: res.token }));
        
        // Navigate to dashboard
        navigate("/");
        
        // Call legacy onLogin for compatibility
        // onLogin();
      } else {
        throw new Error(res.message || "Login failed");
      }
    } catch (error: any) {
      console.log("Login error:", error);
      const errorMessage = error.response?.data?.message || error.message || "Invalid email or password";
      setError(errorMessage);
      dispatch(loginFailure(errorMessage));
    } finally {
      setLoginLoading(false);
    }
  };

    // Mock login data
  //   const mockUserData = {
  //     email: "admin@gmail.com",
  //     password: "Admin@123",
  //     token: "mockToken",
  //     refreshToken: "mockRefreshToken",
  //   };

  //   // Check if the provided credentials match the mock data
  //   if (username === mockUserData.email && password === mockUserData.password) {
  //     // Simulate receiving a token from a real API
  //     const token = mockUserData.token;
  //     const refreshToken = mockUserData.refreshToken;

  //     // Save tokens to local storage (if needed)
  //     localStorage.setItem("accessToken", token);
  //     localStorage.setItem("refreshToken", refreshToken);

  //     onLogin();
  //     navigate("/");
  //   } else {
  //     setError("Invalid username or password");
  //   }
  // };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cover bg-center">
      <div className="bg-white shadow-2xl rounded-lg p-8 w-full max-w-md">
        <div className="flex items-center justify-center mb-6">
      <img className="w-[120px]" src="logo192.png" alt="logo" />
        </div>
        <h1 className="text-2xl font-bold mb-4 text-center text-gray-800">
          Welcome to GK360
        </h1>
        <p className="text-center text-gray-600 mb-6">
          Please sign in to your account
        </p>
        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-700"
            >
              Email
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="Enter your email"
            />
          </div>
          <div className="mb-4 relative">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700"
            >
              Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="••••••••"
            />
            <button
              type="button"
              className="absolute inset-y-0 right-0 pr-3 mt-5 flex items-center text-sm leading-5"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>
          {error && <p className="text-red-500 mb-4">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
